import { ActionIcon, Group } from '@mantine/core'
import { IconTrash } from '@tabler/icons-react'
import PRMStatusSelector from '../../../../../components/Selectors/PRMStatusSelector'

const NotificationDigestItem = ({ item, setWatched, disabled }) => {
    const deleteItem = () => {
        setWatched((prev) => prev.filter((i) => i.id !== item.id));
    }

    const handleChange = (value) => {        
        setWatched((prev) => {
            let newValue = parseInt(value) ? { custom_status: value, status: null } : { status: value ,custom_status: null};
            return prev.map((i) => (i.id === item.id ? { ...i, ...newValue } : i))
        })
    }

    return (
        <Group wrap='nowrap'>
            <PRMStatusSelector size={"md"} noLabel value={item?.custom_status || item?.status} onChange={handleChange} w={"100%"} disabled={disabled} />

            <ActionIcon onClick={deleteItem} color='red' ml={"auto"} variant='light' size={"lg"} disabled={disabled}>
                <IconTrash size={16} />
            </ActionIcon>
        </Group>
    )
}

export default NotificationDigestItem